<template>
  <DetailsSection 
    label="An- und Abreise"
    :message="message"
  >
    <ToggleGroup
      :options="transportationOptions"
      :select="selectTransportation"
      :selected-key="transportation"
      class="d-flex"
    />
  </DetailsSection>
</template>

<script lang="ts">
import { IToggleGroupOption } from '@/components/interfaces'
import { useDetailsStore } from '@/store'
import { useCatalogStore } from '@/store/catalog'
import { mapPriceModelLabel } from '@/store/details/helper'
import { ITransportations, TransportationCategory } from '@/store/details/interfaces'
import { mapState, mapWritableState } from 'pinia'
import { defineComponent } from 'vue'
import ToggleGroup from '../../common/ToggleGroup.vue'
import DetailsSection from '../DetailsSection.vue'

export default defineComponent({
  components: { DetailsSection, ToggleGroup },

  computed: {
    ...mapState(useCatalogStore, {
      catalogCruises: store => store.cruises,
    }),
    ...mapState(useDetailsStore, {
      mandatoryFlightForPriceModel: store => store.mandatoryFlightForPriceModel,
      transportations: store => store.transportations,
      priceModel: store => store.priceModel,
    }),
    ...mapWritableState(useDetailsStore, {
      transportation: 'transportation'
    }),
    
    transportationOptions(): IToggleGroupOption[] {
      return Object.keys(this.transportations).map(transportation => {
        const available = this.transportations[transportation as keyof ITransportations]

        if (transportation === 'Flug') {
          return {
            key: transportation,
            label: 'AIDA-Flug',
            available,
          }
        }

        return {
          key: transportation,
          label: transportation,
          available,
        }
      })
    },

    message() {
      if (this.mandatoryFlightForPriceModel) {
        return `Diese Reise ist nur mit Flug buchbar im ${mapPriceModelLabel(this.priceModel!)} Tarif.`
      }
      return undefined
    },
  },

  methods: {
    selectTransportation(option: TransportationCategory) {
      this.transportation = option
    },
  },
})
</script>
